import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ShieldCheck, Sparkles, Lock } from "lucide-react";
import { Path } from "../../../../static/Constants";
import { colors, borderRadiusPx } from "../../../../theme";

const FooterBrand = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Logo & Brand Name */}
      <Link
        to={Path.root}
        className="autobet-footer-brand"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          textDecoration: "none",
          width: "fit-content",
        }}
      >
        <Box
          component="img"
          src={require("../../../../static/Images/logo.png")}
          alt="AutoBET Logo"
          className="autobet-footer-logo-img"
        />
        <span className="autobet-footer-logo-text">
          <span style={{ color: colors.neutral.white }}>Auto</span>
          <span style={{ color: colors.red[500] }}>BET</span>
        </span>
      </Link>

      {/* Tagline & Description */}
      <Box>
        <Typography
          sx={{
            fontSize: "0.875rem",
            fontWeight: 600,
            color: colors.blue[400],
            letterSpacing: "0.02em",
            mb: 0.75,
          }}
        >
          Decentralized Lottery Ecosystem for Fundraising
        </Typography>

        <Typography
          sx={{
            fontSize: "0.875rem",
            color: colors.slate[300],
            lineHeight: 1.65,
            maxWidth: "360px",
          }}
        >
          AutoBET is a trustless, blockchain-powered gaming platform. Experience
          transparent, cryptographically verifiable lottery draws with
          verifiable fairness.
        </Typography>
      </Box>

      {/* Trust & Security Badges */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, pt: 0.5 }}>
        <Box
          className="autobet-footer-trust-badge"
          sx={{
            backgroundColor: colors.alpha.white[5],
            border: `1px solid ${colors.sidebar.border}`,
            borderRadius: borderRadiusPx.sm,
            color: colors.slate[200],
          }}
        >
          <ShieldCheck size={14} color={colors.emerald[400]} />
          <Typography
            component="span"
            sx={{
              fontSize: "0.75rem",
              fontWeight: 600,
              color: colors.slate[200],
            }}
          >
            100% On-Chain
          </Typography>
        </Box>

        <Box
          className="autobet-footer-trust-badge"
          sx={{
            backgroundColor: colors.alpha.white[5],
            border: `1px solid ${colors.sidebar.border}`,
            borderRadius: borderRadiusPx.sm,
            color: colors.slate[200],
          }}
        >
          <Sparkles size={14} color={colors.blue[400]} />
          <Typography
            component="span"
            sx={{
              fontSize: "0.75rem",
              fontWeight: 600,
              color: colors.slate[200],
            }}
          >
            Chainlink VRF
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterBrand;
